/*
 * @Author: edvardchen
 * @Date: 2017-10-13 17:45:23
 * @Last Modified by: edvardchen
 * @Last Modified time: 2017-10-13 19:32:33
 */

import querystring from 'query-string';

/**
 * crop the image into specific HW
 * @param  {String} url      image url
 * @param  {Number} width
 * @param  {Number} height
 * @param  {String} referer  Referer url
 */
export default ({
  url,
  imageUrl,
  width,
  w,
  height,
  h,
  ...rest
}: {
  url: string,
  imageUrl?: string,
  width: number,
  height: number,
}) => {
  if (url.indexOf('read.html5.qq.com/image?') > -1) {
    return url;
  }

  const params = {
    src: 'read', // business id
    q: 5,
    imgflag: 5,
    r: 4,
    w: width,
    h: height,
    imageUrl: url,
    ...rest,
  };

  return `https://cdn.read.html5.qq.com/image?${querystring.stringify(params)}`;
};
